module.exports = __webpack_public_path__ + "static/media/greenPlace.2a89cf9f.svg";